import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=1dea6f57&"
import script from "./CollapsePanel.vue?vue&type=script&lang=ts&"
export * from "./CollapsePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports